/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { OrganizationStrictHttpResponse } from '../../organization-strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { OrganizationAffiliationSearchResultModel } from '../../models/organization-affiliation-search-result-model';

export interface AdminFhirIdAffiliationGet$Params {
  fhirId: string;
}

export function adminFhirIdAffiliationGet(http: HttpClient, rootUrl: string, params: AdminFhirIdAffiliationGet$Params, context?: HttpContext): Observable<OrganizationStrictHttpResponse<Array<OrganizationAffiliationSearchResultModel>>> {
  const rb = new RequestBuilder(rootUrl, adminFhirIdAffiliationGet.PATH, 'get');
  if (params) {
    rb.path('fhirId', params.fhirId, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'text/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as OrganizationStrictHttpResponse<Array<OrganizationAffiliationSearchResultModel>>;
    })
  );
}

adminFhirIdAffiliationGet.PATH = '/Admin/{fhirId}/Affiliation';
